module.exports = __webpack_public_path__ + "img/11087923_L.7063719b.png";